import React from 'react';
import { motion } from 'framer-motion';
import { LayoutDashboard, RefreshCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { isSaudiBrand } from '../../../products/saudi/utils/isSaudiBrand';

export default function DashboardLayout({
  title,
  subtitle,
  icon: Icon = LayoutDashboard,
  accent = 'from-emerald-600 to-emerald-800',
  loading = false,
  error = null,
  onRefresh,
  children,
}) {
  const { t } = useTranslation();
  const qawaem = isSaudiBrand();

  return (
    <div className="space-y-6 employees-container min-h-full">
      <motion.div
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex flex-wrap justify-between items-start gap-4 list-toolbar-mobile-layout"
      >
        <div className="min-w-0">
          <h1
            className={`text-3xl font-bold flex items-center gap-3 flex-wrap ${
              qawaem ? 'text-forest-900' : 'text-white'
            }`}
          >
            {qawaem ? (
              <Icon className="page-title-icon page-title-icon--bronze h-8 w-8 shrink-0" aria-hidden />
            ) : (
              <div className={`p-3 rounded-xl bg-gradient-to-r ${accent}`}>
                <Icon className="h-8 w-8 text-white" aria-hidden />
              </div>
            )}
            {title}
            {onRefresh ? (
              <button
                type="button"
                onClick={onRefresh}
                className="refresh-button"
                title={t('common.refresh', { defaultValue: 'تحديث' })}
              >
                <RefreshCcw size={20} className={loading ? 'animate-spin' : ''} />
              </button>
            ) : null}
          </h1>
          {subtitle ? (
            <p className={qawaem ? 'page-section-desc' : 'text-white/60 mt-2'}>{subtitle}</p>
          ) : null}
        </div>
      </motion.div>

      {error ? (
        <div
          className={`glass-panel border p-4 text-sm ${
            qawaem ? 'border-rose-300/50 text-rose-700' : 'border-rose-400/30 text-rose-200'
          }`}
        >
          {error}
        </div>
      ) : null}

      {loading && !children ? (
        <div className={`glass-panel p-10 text-center ${qawaem ? 'text-console-muted' : 'text-white/60'}`}>
          {t('common.loading', { defaultValue: 'جاري التحميل...' })}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
